import React, { useEffect } from "react";
import NotificationIcon from "../icons/NotificationIcon";
import { Paths } from "../../../../Paths";
import { useInformationList } from "../../../hooks/information/useInformationList";
import { getInformationListAction } from "../../../../state/usecase/information/actions";
import { useAppDispatch } from "../../../../state/store";
import { UnreadCount } from "../../common/UnreadCount";
import { useNavigate } from "react-router-dom";

export default function InformationButton() {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const informationList = useInformationList();
    useEffect(() => {
        if (informationList === null) dispatch(getInformationListAction());
    });

    const unread = informationList?.filter( (info) => !info.isRead);

    const handleClicked = () => {
        navigate(`${Paths.information}${Paths.list}`);
    };

    return (
        <button className={"information_button"} onClick={handleClicked}>
            <NotificationIcon/>
            <div>お知らせ</div>
            <UnreadCount unreadCount={unread?.length} top={"-25%"} right={"0"} />
        </button>
    );
}
